
export const NOTIFICATION = "NOTIFICATION"

/**
 * create new notification.
 * @msg { String } notification message.
 * @type { String } animation type. [ success | danger ]
 * @time { Number } animation timing. The unit is millseconds.
 */
export const openNotification = (msg, type, options) => {
    return dispatch => {
        dispatch({
            type: NOTIFICATION,
            payload: { msg: msg, type: type, options: options }
        });
    }
};

/**
 * close notification.
 */
export const closeNotification = () => {
    return dispatch => {
        dispatch({
            type: NOTIFICATION,
            payload: { msg: '' }
        });
    }
}
